<template>
	<edit-layout @save="saveProblem" @cancel="$emit('browsMode')">
		<el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-position="left" label-width="110px">
			<el-form-item label="感受到的問題" prop="problem">
				<el-input type="textarea" placeholder="請簡短敘述您感受到的問題" :autosize="{ minRows: 3}" v-model="ruleForm.problem"></el-input>
			</el-form-item>
		</el-form>
	</edit-layout>
</template>

<script>
import EditLayout from "./EditLayout.vue";
import { mapActions, mapMutations } from "vuex";

export default {
	components: { EditLayout },
	props: ["editStoryData"],
	data() {
		return {
			ruleForm: {
				problem: ""
			},
			rules: {
				problem: [
					{ required: true, message: "資料未填寫完整", trigger: "blur" }
				]
			}
		};
	},
	methods: {
		...mapMutations("story", ["updateEditStoryData"]),
		...mapActions("story", ["updateStory", "checkProgress"]),
		saveProblem() {
			this.$refs["ruleForm"].validate(async valid => {
				if (valid) {
					let data = {
						id: this.editStoryData.id,
						problem: this.ruleForm.problem
					};
					this.updateEditStoryData(data);
					data.progress = await this.checkProgress();
					await this.updateStory(data);
					this.$emit("browsMode");
					this.$message.success("儲存成功");
				} else {
					this.$message.error("資料要填完整喔！");
				}
			});
		},
		init() {
			this.ruleForm = {
				problem: this.editStoryData.problem
			};
		}
	},
	created() {
		this.init();
	}
};
</script>